import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'
import { ModalDialog } from '@/scripts/interactive-defer/modal-dialog'

export class ContactFormModal extends UcoastEl {
    static htmlSelector = 'contact-form-modal'

    constructor() {
        super()
        this.setupEventListeners()
    }

    public open(): void {
        this.setAttribute('open', '')
    }

    public close(): void {
        this.removeAttribute('open')
    }

    private setupEventListeners(): void {
        const closeButtons = this.querySelectorAll<HTMLElement>('[id^="ModalClose-"]')
        closeButtons?.forEach((closeButton) => {
            closeButton.addEventListener('click', () => this.close())
        })
    }
}